export { configureSalesTools, type SalesToolsConfig } from "./config";
export type {
    Address,
    BillingAccountNumberGetCustomerDetailsParams,
    Customer,
    CustomerDetailsPayload,
    CustomerDetailsRequestBody,
    DeviceReplacement,
    Feature,
    GetCustomerDetailsParams,
    Intent,
    PhoneNumberGetCustomerDetailsParams,
    Product,
    SearchType,
    SessionSummary,
    TimeZone,
} from "./types/domain";
export { assistMessageSuggestions, features, intents, productMappings, products } from "./types/domain";
export type {
    SalesAnalytics,
    SalesAnalyticsDispatcher,
    SalesContextValue,
    SalesFeatures,
    SalesTimeline,
    TimelineMessage,
} from "./sales-context/SalesContext.types";
export { SalesContextProvider, useSalesContext } from "./sales-context/SalesContext";
export {
    useCallDetailsStore,
    useCallIntroStore,
    useDetectedCuesStore,
    useIntegratedFlowStore,
    useOfferChecklistStore,
    useProductOfferStore,
    useRapportBuildingStore,
    useVerificationFlowStore,
    useVerifiedCustomerStore,
} from "./stores";
export type {
    CallIntroStep,
    CustomerState,
    CustomerVerificationStep,
    Location,
    OfferChecklistKey,
    OfferChecklistState,
} from "./stores";
export { EligibilityStatus, SaleProgress } from "./types";
export type { EligibilityMeta, EligibleProduct, SmartLinkMeta } from "./types";
export { CustomerPanel } from "./modules/customer-panel";
export { ProductSaleFlow } from "./modules/product-sale-flow";
export { WidgetContainer } from "./modules/widget-container";
export { handleEnrollmentEvent, type EnrollmentEventData } from "./handlers/handleEnrollmentEvent";
export { handleSessionEnd } from "./stores/useRapportBuildingStore";
export * from "./modules/dynamic-smart-offer/DynamicCoreBenefits/DynamicCoreBenefits";
export * from "./modules/dynamic-smart-offer/DynamicToneGuidance/DynamicToneGuidance";
export * from "./modules/dynamic-smart-offer/DynamicSmartOffer";
export * from "./modules/dynamic-smart-offer/hooks/useDynamicSmartOffer";
export * from "./modules/dynamic-smart-offer/hooks/useDynamicSmartOfferListener";
export * from "./modules/dynamic-smart-offer/store/useDynamicSmartOfferStore";
